import AboutUsPage from 'screens/AboutUs/AboutUs';

export default AboutUsPage;
